export enum IntervalEnum {
  ONE_MINUTE = '00:01:00',
  THREE_MINUTES = '00:03:00',
  FIVE_MINUTES = '00:05:00',
  FIFTEEN_MINUTES = '00:15:00',
  THIRD_MINUTES = '00:30:00',
  ONE_HOUR = '01:00:00',
  TWO_HOURS = '02:00:00',
  THREE_HOURS = '03:00:00',
  FOUR_HOURS = '04:00:00',
  SIX_HOURS = '06:00:00',
  EIGHT_HOURS = '08:00:00',
  DAILY = '24:00:00',
  WEEKLY = '168:00:00',
  MONTHLY = '720:00:00',
}
